import { sw_api } from "./helpers";
import { ensureSubscribe } from './sw_subscribe';

var _current_registration = null;


export function swRegistrationUpdate() {
  console.log("[sw] reg.update()")
  _current_registration && _current_registration.update();
}

export function getSwRegistration() {
  return _current_registration;
}

// return true if a SW is being installed or installed
export function updateFound() {
  if (!_current_registration) { return false; }
  return _current_registration.installing || _current_registration.waiting;
}


function log () {
  console.log.apply(console, arguments);
}

// send skipWaiting
// installing -> waiting
export function listenForWaitingServiceWorker(reg, callback) {
  function awaitStateChange() {
    reg.installing.addEventListener('statechange', function () {
        log("[sw] state change: " + this.state)
        if (this.state === 'installed') {
            callback(reg);
        }
    });
  }
  if (!reg) return;

  if (reg.waiting) {
    log("[sw] reg.waiting")
    return callback(reg);
  }
  if (reg.installing) {
    log("[sw] reg.installing")
    awaitStateChange();
  }
  reg.addEventListener('updatefound', awaitStateChange);
}

// reload once when the new Service Worker starts activating
export function listenForActivatingServiceWorker(reg, callback) {
  log("[sw] plugging listenForActivateSW");

  var refreshing;
  navigator.serviceWorker.addEventListener('controllerchange', () => {
    log("[sw] controller change")
    if (refreshing) return;
    refreshing = true;

    // subsribe to push notification when the new service worker becomes active
    // will fail if user is not logged in!
    ensureSubscribe(reg);
    callback();
  });
}


// https://solidstudio.io/blog/pwa-refreshing-application
function onRegister(registration, first_sw_controller, res, rej) {
  _current_registration = registration;

  log("[sw setup] on register, scope: " + registration.scope);

  // listenForWaitingServiceWorker(registration, () => console.log("New update, installed"));

  // listenForActivatingServiceWorker(registration, () => console.log("Controller change"))

  // if this is the first sw:
  // don't wait to take control of the page and don't reload the page (as in update)
  // take control immediately
  if (first_sw_controller) {
    navigator.serviceWorker.ready.then((reg) => {
      log("[sw] calling clients claim");
      sw_api.clientsClaim();

      log("[sw] ensure subscribe on install")
      // may fail if user is not connected
      // this case is for very rare usage: user is logged in but no service worker...
      ensureSubscribe(reg);
    })
  }

  if (registration.active) {
    log("[sw setup] registration done: already active");
  } else {
    console.log(registration);
    log("[sw setup] registration done: new sw ready!");
    // cant subscribe here: failed to execute subscribe on pushmanager subscription failed - no active service worker
  }

  res(true);
}

function registerSW(sw_url, scope) {
  log("[sw setup] start registration at: " + sw_url);
  return new Promise((res, rej) => {
    if (window.navigator?.serviceWorker) {

     const first_sw_controller = !navigator.serviceWorker.controller;

      navigator.serviceWorker.register(sw_url, {scope})
      .then(
        (registration) => onRegister(registration, first_sw_controller, res, rej)
        , () => rej(false)
      )
    } else {
      rej(false)
    }
  })
}
export default registerSW;
